module.exports = __webpack_public_path__ + "img/cat_sanofiaventis-small.f764117a.jpg";